import * as React from 'react';

/**
 * Calendar Power Icon
 *
 * @returns
 */
function CalendarPowerSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 35 32"
			className={'icon icon-calendar-power ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
			data-testid={svgProps.testId}
		>
			<path d="M20.93 6.621c1.197-0.004 2.165-0.974 2.165-2.172 0 0 0 0 0 0v0-2.277c-0.046-1.165-1.001-2.091-2.173-2.091s-2.127 0.927-2.173 2.087l-0 0.004v2.277c0 0 0 0 0 0 0 1.199 0.972 2.172 2.172 2.172 0.003 0 0.007 0 0.010-0h-0.001z" />
			<path d="M20.966 16.552h1.014c0.661-0.456 1.42-0.846 2.228-1.133l0.069-0.021v-2.156h-3.31z" />
			<path d="M15.448 24.276v3.31h2.566c-0.246-0.826-0.387-1.775-0.387-2.757 0-0.195 0.006-0.388 0.017-0.58l-0.001 0.027z" />
			<path d="M19.958 31.172c-0.339-0.406-0.657-0.856-0.937-1.333l-0.025-0.047h-16.789v-18.759h24.276v3.865c0.263-0.029 0.526-0.048 0.789-0.055 0.135-0.017 0.291-0.027 0.45-0.027 0.215 0 0.425 0.018 0.631 0.053l-0.022-0.003 0.359 0.032v-9.383c0-1.219-0.988-2.207-2.207-2.207v0h-2.207v1.103c0 1.828-1.482 3.31-3.31 3.31s-3.31-1.482-3.31-3.31v0-1.103h-6.621v1.103c0 1.828-1.482 3.31-3.31 3.31s-3.31-1.482-3.31-3.31v0-1.103h-2.207c-1.219 0-2.207 0.988-2.207 2.207v0 24.276c0 1.219 0.988 2.207 2.207 2.207h18.537c-0.276-0.26-0.533-0.53-0.774-0.813l-0.012-0.014z" />
			<path d="M15.448 18.759v3.31h2.544c0.21-0.738 0.471-1.376 0.793-1.978l-0.026 0.053v-1.386z" />
			<path d="M15.448 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M7.698 6.621c0 0 0 0 0 0 1.2 0 2.173-0.972 2.175-2.171v-2.278c-0.046-1.165-1.001-2.091-2.173-2.091s-2.127 0.927-2.173 2.087l-0 0.004v2.277c0 1.199 0.972 2.172 2.172 2.172v0z" />
			<path d="M4.414 24.276h3.31v3.31h-3.31v-3.31z" />
			<path d="M4.414 18.759h3.31v3.31h-3.31v-3.31z" />
			<path d="M4.414 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 18.759h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 24.276h3.31v3.31h-3.31v-3.31z" />
			<path d="M9.931 13.241h3.31v3.31h-3.31v-3.31z" />
			<path d="M34.752 24.767c0 0.002 0 0.005 0 0.008 0 3.979-3.226 7.204-7.204 7.204s-7.204-3.226-7.204-7.204c0-1.761 0.631-3.374 1.68-4.625l-0.009 0.011c0.078-0.148 0.187-0.271 0.318-0.364l0.003-0.002 0.067-0.074s0 0.022 0 0.032c0.152-0.094 0.337-0.15 0.534-0.15 0.567 0 1.027 0.46 1.027 1.027 0 0.37-0.195 0.694-0.489 0.875l-0.004 0.003 0.051 0.042c-0.699 0.87-1.123 1.987-1.123 3.204 0 2.834 2.298 5.132 5.132 5.132s5.132-2.298 5.132-5.132c0-1.216-0.423-2.334-1.13-3.214l0.008 0.010 0.051-0.042c-0.298-0.183-0.493-0.508-0.493-0.877 0-0.567 0.46-1.027 1.027-1.027 0.197 0 0.382 0.056 0.538 0.152l-0.004-0.003s0-0.022 0-0.032l0.067 0.074c0.134 0.095 0.242 0.218 0.318 0.36l0.003 0.006c1.052 1.234 1.695 2.844 1.703 4.604v0.002zM28.061 25.796h-1.026c-0.285 0-0.516-0.231-0.516-0.516v0-7.204c0.002-0.284 0.232-0.513 0.516-0.513 0 0 0 0 0 0h1.026c0 0 0 0 0 0 0.284 0 0.515 0.229 0.516 0.513v7.205c0 0.285-0.231 0.516-0.516 0.516v0z" />
		</svg>
	);
}

CalendarPowerSVG.defaultProps = { class: '' };

export default CalendarPowerSVG;
